import React, { useContext, useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Card, Button, Dropdown, Image, Alert, Modal, Col, Form} from 'react-bootstrap';

import { Link, redirect, useNavigate } from "react-router-dom";

import { AuthContext } from "../../../Authentication/AuthProvider";
import { auth, firestore } from "../../../Database/firebase";
import { getDocs } from "firebase/firestore";

import "./../../../component_home/content/content.css"

import { BsSearch } from "react-icons/bs";
import { FaBook } from "react-icons/fa";

function MerchantIncomeWebios() {

    const [currentUser, setCurrentUser] = useState(null);
    const authContext = useContext(AuthContext);

    const navigate = useNavigate();

    var user = auth.currentUser;

    var uid = "";

    if (user != null) {
        
        uid = user.uid;  
        console.log(uid);
        
    } else {
          
            navigate("/");
            
        }

    //CHECHK ROLE
    const [role, setRole] = useState("");
    const [displayName, setDisplayName] = useState("");
    useEffect(() => {
        const userRef = firestore.collection("user");
        const query = userRef
        
            .where("uid", "==", uid);
                query
                .get()
                .then((querySnapshot) => {
                    let tempDataArray =[];
                    querySnapshot.forEach((doc) => {
                        if (doc.exists) {
                            console.log(doc.data());
                            tempDataArray = [...tempDataArray,
                            {
                                uid: doc.id,
                                role: doc.data().role,
 
                            },
                            
                        ];
   
    
                        setRole(doc.data().role);
                        setDisplayName(doc.data().displayName);
                        
                        
                        };
    
                    });
    
                
            },
    
                (err) => {
                    console.log(err);
                }
                
            );
    
        }, [uid]); 




        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
    
        const [selectedStartMonthDuration, setSelectedStartMonthDuration] = useState("กรุณาเลือกเดือน");
        //console.log("selectedStartMonthDuration " + selectedStartMonthDuration);
        const [selectedEndMonthDuration, setSelectedEndMonthDuration] = useState(selectedStartMonthDuration);
    
        //const [month, setMonth] = useState(currentMonth - 1);
        /* const startMonthDuration = [
          {key:'1', value:1},
          {key:'2', value:2},
          {key:'3', value:3},
          {key:'4', value:4},
          {key:'5', value:5},
          {key:'6', value:6},
          {key:'7', value:7},
          {key:'8', value:8},
          {key:'9', value:9},
          {key:'10', value:10},
          {key:'11', value:11},
          {key:'12', value:12},
        ] */
    
          const [selectedStartYearDuration, setSelectedStartYearDuration] = useState(2025);
          const [selectedEndYearDuration, setSelectedEndYearDuration] = useState(2025);
    
          /* const startYearDuration = [
            {key:'1', value:2025},
           
    
          ]
    
          const endYearDuration = [
            {key:'1', value:2025},
            
          ] */
    
          
    
        function getThaiMonth(date) {
            const thaiMonths = [
                "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
            ];
            return thaiMonths[date.getMonth()]
            
        }
    
        const startMonthIncome = new Date(selectedStartYearDuration, selectedStartMonthDuration , 1);

        const startOfMonth = new Date(selectedStartYearDuration, selectedStartMonthDuration , 1); // เริ่มต้นเดือน 2025
        const endOfMonth = new Date(selectedEndYearDuration, selectedEndMonthDuration + 1, 1); // สิ้นเดือน 2025

       /*  console.log("startOfMonth" + startOfMonth);
        console.log("endOfMonth" + endOfMonth); */
        


        const [merchantID, setMerchantID] = useState();
        const [merchantName, setMerchantName] = useState();
    
            
          /* QUERY DATA */
          const [productLists, setProductLists] = useState([]);
          const [currentCursor, setCurrentCursor] = useState("");
      
          useEffect(() => {
    
            
    
    
            const fetchData = async () => {

              console.log("startOfMonth" + startOfMonth);
            console.log("endOfMonth" +endOfMonth);

              try {
    
              const firstPageRef = firestore
                  .collection("order")
                  .where("merchantID", "==", uid)
                  .where('perchaseDate', '>=', startOfMonth)
                  .where('perchaseDate', '<=', endOfMonth)
                  .where('bookPlatform', '==', 'webios')
                  .orderBy("perchaseDate", "desc")
                  firstPageRef.onSnapshot((snapshot) => {
                    let tempLists = [];
                    snapshot.forEach((doc) => {
    
    
                      if (doc.exists) {
    
                        setMerchantID(doc.data().merchantID);
                        setMerchantName(doc.data().merchantName);
    
      
                          const currentOrder = {
      
                            id: doc.id,
                            productID: doc.data().productID,
                            merchantName: doc.data().merchantName,
                            productName: doc.data().productName,
                            productImage: doc.data().productImage,
                            productFullPrice: doc.data().productFullPrice,
                            productDiscount: doc.data().productDiscount,
                            productPrice: doc.data().productPrice, 

    
                            productDate: doc.data().productDate,
                            perchaseDate: doc.data().perchaseDate,
    
                            productType: doc.data().productType,
       
                            bookPlatform: doc.data().bookPlatform,
    
               
    
                            orderID: doc.data().orderID,
              
      
                          };
                          tempLists = [...tempLists, currentOrder];
    
                         
                          
    
    
                         
                          
                      }
                  });

                  setProductLists(tempLists);
    
    
              })

            } catch (error) {
              console.error("Error fetching documents: ", error);
            }

          };


          fetchData();


          }, [selectedStartMonthDuration]);




         /*     useEffect(() => {
      
              const fetchData = async () => {
                try {
                  {
                          const userRef = firestore.collection("order");
                          const query = userRef
                          
                          .where("merchantID", "==", uid)
                          .where('perchaseDate', '>=', startOfMonth)
                          .where('perchaseDate', '<=', endOfMonth)
                          .where('bookPlatform', '==', 'ios')
                          .orderBy("perchaseDate", "desc")
                                  query
                                  .get()
                                  .then((querySnapshot) => {
                                      let tempDataArray =[];
                                      querySnapshot.forEach((doc) => {
                                          if (doc.exists) {
                                              console.log(doc.data());
                                              tempDataArray = [...tempDataArray,
                                              {
                                                id: doc.id,
                                                productID: doc.data().productID,
                                                merchantName: doc.data().merchantName,
                                                productName: doc.data().productName,
                                                productImage: doc.data().productImage,
                                                productFullPrice: doc.data().productFullPrice,
                                                productDiscount: doc.data().productDiscount,
                                                productPrice: doc.data().productPrice, 
                    
                        
                                                productDate: doc.data().productDate,
                                                perchaseDate: doc.data().perchaseDate,
                        
                                                productType: doc.data().productType,
                           
                                                bookPlatform: doc.data().bookPlatform,
                        
                                   
                        
                                                orderID: doc.data().orderID,
                      
                                                  
                                              },
                                              
                                          ];
    
                      
                                          setRole(doc.data().role)

                                          };
                      
                                      });
                      
                                  setProductLists((oldDataArray) => tempDataArray);
                                  
                      
                              },
                      
                                  (err) => {
                                      console.log(err);
                                  }
                                  
                              );
                      
                          }

                } catch (error) {
                  console.error("Error fetching documents: ", error);
                }
              };
          
              fetchData();
            }, [selectedStartMonthDuration]);
 */
            























    
    
          const totalAmount = productLists.reduce((sum, item) => {
            return sum + parseFloat(item.productPrice);
          }, 0);
    
          const resultAmount = (35 / 100) * totalAmount;
    
          const resultIncome = totalAmount - resultAmount;

   
    return (
  
      <Container>


        {(role == 'admin' || role == 'merchant') ? (

        <>

        <br/>
        <h3 style={{fontWeight: 'bold'}}><strong><FaBook /> รายได้ของ <span style={{color: 'dodgerblue'}}>{displayName}</span></strong></h3>

        <br/>

        <h3>รายได้การขายผ่านเว็บไซต์ (ios)</h3>

            <div style={{marginTop: 10}}>
            <p style={{marginBottom: 10, fontWeight: 'bold', fontSize: 18}}>เลือกเดือนที่แสดงยอดขาย : </p>
            <p style={{marginBottom: 10, fontSize: 10}}>(พ.ศ. 2568)</p>
          {/*   <Form.Select 
                    setSelected={(val) => setSelectedStartMonthDuration(val - 1)} 
                    data={startMonthDuration} 
                    save="value" 
                    boxStyles={{borderRadius:0, borderColor: 'dodgerblue'}}
                    placeholder='กรุณาเลือกเดือน'
                    search={false}

            /> */}

            <Form.Group controlId="formBasicSelect">
                  {/* <Form.Label>กรุณาเลือกเดือน (พ.ศ. 2568)</Form.Label> */}
                  <Form.Select aria-label="Default select example"
                    as="select"
                    value={selectedStartMonthDuration}
                    onChange={e => {
                      console.log("e.target.value", e.target.value);
                      setSelectedStartMonthDuration(parseInt(e.target.value));
                      setSelectedEndMonthDuration(parseInt(e.target.value));
                      //setMonth(e.target.value);
                    
                    }} 
                  >

                   <option disabled>กรุณาเลือกเดือน</option>
                    <option value={0}>มกราคม 2568</option>
                    <option value={1}>กุมภาพันธ์ 2568</option>
                    <option value={2}>มีนาคม 2568</option>
                    <option value={3}>เมษายน 2568</option>
                    <option value={4}>พฤษภาคม 2568</option>
                    <option value={5}>มิถุนายน 2568</option>
                    <option value={6}>กรกฎาคม 2568</option>
                    <option value={7}>สิงหาคม 2568</option>
                    <option value={8}>กันยายน 2568</option>
                    <option value={9}>ตุลาคม 2568</option>
                    <option value={10}>พฤศจิกายน 2568</option>
                    <option value={11}>ธันวาคม 2568</option>
                  </Form.Select>
            </Form.Group>


            </div>

            <br/>

            <Card className="rounded-0">
  

                
                   

                     
                        <Card.Header>
                        <p style={{fontSize: 14, color: 'blue', fontWeight: 'bold'}}>
                          Platform : IOS
                        </p>
                        </Card.Header>
                     

                        <Card.Body>
                          <Card.Text>
                    <p style={{fontSize: 14, fontWeight: 'bold'}}>
                      การขายในเดือน : {getThaiMonth(startMonthIncome)} 2568
                    </p>
                    <p style={{fontSize: 14, marginTop: 5}}>
                      ชื่อผู้ขาย : {merchantName}
                    </p>
                    <p style={{fontSize: 10, color: 'dimgray'}}>
                      รหัสผู้ขาย : {merchantID}
                    </p>
                    
                    <p style={{fontSize: 12, marginTop: 6,}}>
                      ยอดขายรวม : {totalAmount} บาท
                    </p>
                    <p style={{fontSize: 12, marginTop: 2,}}>
                      หักค่าดำเนินการ : 35%
                    </p>
                    <p style={{fontSize: 14,fontWeight: 'bold', color: 'green', marginTop: 5,}}>
                      รายได้สุทธิโดยประมาณ : {resultIncome} บาท
                    </p>
                    </Card.Text>

                  </Card.Body>

                    
                  
          </Card>

          <h3 style={{marginTop: 40, fontWeight: 'bold', fontSize: 18}}>รายการ : </h3>

       

            {!!productLists ? 
                    (
                        <>

                            <Row>
            
                                {productLists.map((item, index) => {
                                    return (
                                        <div key={index}>     
                                        {/* <h3 className="pb-3 border-bottom"></h3> */}
                                            <br/>
                                            <Card className="rounded-0">
                                                <Card.Header>
                                                    <strong>{item.productName}</strong>
                                                </Card.Header>
                                            <Card.Body>
            
                                            {/* <Card.Img style={{marginLeft: 'auto', marginRight: 'auto', width: 140, height: 200}} src={item.productImage} /> */}
                                    
                                                <Card.Text>
                                                    
                                                   <strong>วันที่ขาย : {(item.perchaseDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})}</strong><br/>
                                                    <strong>เลขที่คำสั่งซื้อ : {item.orderID}</strong><br/>
                                                    <strong>รหัสสินค้า:</strong> {item.productID}<br/>
                                                    <strong>ร้านค้า : {item.merchantName}</strong><br/>
                                                    
                                                    <strong>ราคาเต็ม:</strong> {item.productFullPrice}<br/>
                                                    <strong>ส่วนลด:</strong> {item.productDiscount} %<br/>
                                                    <strong>ราคาขาย:</strong> {item.productPrice}<br/>
                                                    <strong>ขายในระบบ:</strong> {item.bookPlatform}<br/>
                                                    {/* <strong>วันที่ลงขาย : {(item.productDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})}</strong> */}
                                                    
       
                                                    <br/>
                                                  
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
            
                                        </div>
                                    );
                                })}
                        
                            </Row>
                            <br/>
            
                            {/* {currentCursor ? (
                                <Button variant="outline-dark" onClick={() => {onMoreBook()}} style={{display: 'flex', marginLeft: 'auto', marginRight: 'auto'}}> 
                                    แสดงเพิ่มเติม
                                </Button>
                                ) : (
                                <Button variant="outline-dark" style={{display: 'flex', marginLeft: 'auto', marginRight: 'auto'}}> 
                                    ไม่มีสินค้าเพิ่มเติม
                                </Button>
                            )} */}
            
                        </>
            
                    ) : (
            
                        <>
                            <br/>
                            <h3><strong>สินค้าของฉัน</strong></h3>
                            <h3 className="pb-3 border-bottom"></h3>
                            <br/>
                            <p>ไม่พบสินค้าของฉัน</p>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                        </>
            
                    )}

        </>
    
         ) : (

            <>
                <br/>
                <h3><strong>กำลังดำเนินการ</strong></h3>
                <h3 className="pb-3 border-bottom"></h3>
                <br/>
                <p>กำลังดำเนินการโหลดข้อมูล</p>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            
            </>
        )}

        
    
        

        <br/>
        <br/>


        {/* <Modal 
            show={showAddCouponCode} 
            onHide={handleCloseAddCouponCode} 
            animation={false} 
            size="m"
            aria-labelledby="contained-modal-title-vcenter"
            centered>

            <Modal.Header>
                <Modal.Title>เพิ่ม Coupon Code</Modal.Title>
            </Modal.Header>
                                          
            <Modal.Body>
                เพิ่ม Coupon Code หนังสือ {productName} เพื่อจำหน่ายในระบบ ios {productID}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseAddCouponCode}>
                    ยกเลิก
                </Button>
                <Button variant="primary" onClick={submitHandler}>
                    เพิ่ม Coupon Code
                </Button>
            </Modal.Footer>
        </Modal> */}

      </Container>
    );
  }
  
  export default MerchantIncomeWebios;